/* eslint-disable import/order */
/* eslint-disable import/no-duplicates */
import { Scope } from './Scope.js';
import { createG } from './lib/globals.js';
import { operators } from './operators.js';
import { Table } from './Table.js';
import { LuaError } from './LuaError.js';
import { libMath } from './lib/math.js';
import { libTable } from './lib/table.js';
import { libString, metatable as stringMetatable } from './lib/string.js';
import { getLibOS } from './lib/os.js';
import { getLibPackage } from './lib/package.js';
import { ensureArray } from './utils.js';
import { parse as parseScript } from './parser.js';
const call = (f, ...args) => {
    if (f instanceof Function)
        return ensureArray(f(...args));
    const mm = f instanceof Table && f.getMetaMethod('__call');
    if (mm)
        return ensureArray(mm(f, ...args));
    throw new LuaError(`attempt to call an uncallable type`);
};
const stringTable = new Table();
stringTable.metatable = stringMetatable;
const get = (t, v) => {
    if (t instanceof Table)
        return t.get(v);
    if (typeof t === 'string')
        return stringTable.get(v);
    throw new LuaError(`no table or metatable found for given type`);
};
const execChunk = (_G, chunk, chunkName) => {
    const exec = new Function('__lua', chunk);
    const globalScope = new Scope(_G.strValues).extend();
    if (chunkName)
        globalScope.setVarargs([chunkName]);
    const res = exec({
        globalScope,
        ...operators,
        Table,
        call,
        get
    });
    return res === undefined ? [undefined] : res;
};
function createEnv(config = {}) {
    const cfg = {
        LUA_PATH: './?.lua',
        stdin: '',
        stdout: console.log,
        ...config
    };
    const _G = createG(cfg, execChunk);
    const { libPackage, _require } = getLibPackage((content, moduleName) => execChunk(_G, parseScript(content), moduleName)[0], cfg);
    const loaded = libPackage.get('loaded');
    const loadLib = (name, value) => {
        _G.rawset(name, value);
        loaded.rawset(name, value);
    };
    loadLib('_G', _G);
    loadLib('package', libPackage);
    loadLib('math', libMath);
    loadLib('table', libTable);
    loadLib('string', libString);
    loadLib('os', getLibOS(cfg));
    _G.rawset('require', _require);
    const parse = (code) => {
        const script = parseScript(code);
        return {
            exec: () => execChunk(_G, script)[0]
        };
    };
    const parseFile = (filename) => {
        if (!cfg.fileExists)
            throw new LuaError('parseFile requires the config.fileExists function');
        if (!cfg.loadFile)
            throw new LuaError('parseFile requires the config.loadFile function');
        if (!cfg.fileExists(filename))
            throw new LuaError('file not found');
        return parse(cfg.loadFile(filename));
    };
    return {
        parse,
        parseFile,
        loadLib
    };
}
// eslint-disable-next-line import/first
import * as utils from './utils.js';
export { createEnv, Table, LuaError, utils };
